import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { HelperService } from '../core/services/helper.service';
import { AuthService } from '../core/services/auth.service';
import { firstValueFrom } from 'rxjs';
import { MaterialModule } from '../material.module';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-pages-dashboard',
    imports: [MaterialModule],
    standalone: true,
    template: `<div class="container full-height">
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center align-items-center">
                            <mat-spinner diameter="32"></mat-spinner>
                            <p>Redirection to your dashboard...</p>
                        </div>
                    </div>
            </div>`,
})
export class PagesDashboardComponent {
    title = 'ArturPro';

    currentUser = this.authService.currentUser();

    constructor(
        private msalService: MsalService,
        private helperService: HelperService,
        private router: Router,
        private authService: AuthService
    ) { }

    async ngOnInit() {
        if (this.currentUser) {
            if (!this.helperService.allUsers || this.helperService.allUsers.length == 0) {
                await firstValueFrom(this.helperService.get_all_users());
            }
            if (environment.maintenanceMode) {
                this.router.navigate(['/authentication/maintenance']);
            }
            else {
                const redirect = localStorage.getItem('redirect');
                if (redirect) {
                    this.router.navigate([redirect]);
                    localStorage.removeItem('redirect');
                } else {
                    if (this.currentUser.group.includes('admin') || this.currentUser.group.includes('superadmin')) {
                        this.router.navigate(['/admin/admin-dashboard']);
                    } else if (this.currentUser.group.includes('exec') || this.currentUser.group.includes('m_exec')) {
                        this.router.navigate(['/execution/execution-dashboard']);
                    } else if (this.currentUser.group.includes('kyc_bo') || this.currentUser.group.includes('ext_kyc_bo') || this.currentUser.group.includes('kyc_validator')) {
                        this.router.navigate(['/kyc/kyc-dashboard']);
                    } else if (this.currentUser.group.includes('billing')) {
                        this.router.navigate(['/billing/billing-dashboard']);
                    } else if (this.currentUser.group.includes('busdev') || this.currentUser.group.includes('collab') || this.currentUser.group.includes('m_com')) {
                        this.router.navigate(['/crm/crm-dashboard']);
                    } else if (this.currentUser.group.includes('payment_agent')) {
                        this.router.navigate(['/payment/payment-dashboard']);
                    } else if (this.currentUser.group.includes('cde_manager') || this.currentUser.group.includes('cde_admin')) {
                        this.router.navigate(['/crm/crm-cde-management']);
                    }
                }
            }
        }
    }
}
